"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.map.js");
var _react = _interopRequireDefault(require("react"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _Search = _interopRequireDefault(require("./Search"));
var _Menu = _interopRequireDefault(require("./Menu"));
var _data = _interopRequireDefault(require("./data"));
// 模拟数据

var Dropdown = function Dropdown(props) {
  var _props$isActive = props.isActive,
    isActive = _props$isActive === void 0 ? false : _props$isActive,
    _props$dropdownMenu = props.dropdownMenu,
    dropdownMenu = _props$dropdownMenu === void 0 ? _data.default.dropdownMenu : _props$dropdownMenu,
    curItem = props.curItem,
    emptyList = props.emptyList,
    _props$close = props.close,
    close = _props$close === void 0 ? function () {} : _props$close,
    _props$onDropDown = props.onDropDown,
    onDropDown = _props$onDropDown === void 0 ? function () {} : _props$onDropDown,
    _props$onMouseEnter = props.onMouseEnter,
    _onMouseEnter = _props$onMouseEnter === void 0 ? function () {} : _props$onMouseEnter,
    _props$onMouseLeave = props.onMouseLeave,
    _onMouseLeave = _props$onMouseLeave === void 0 ? function () {} : _props$onMouseLeave;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('nav');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__dropdown ").concat(isActive ? 'isActive' : ''),
    onMouseEnter: function onMouseEnter() {
      return _onMouseEnter();
    },
    onMouseLeave: function onMouseLeave() {
      return _onMouseLeave();
    }
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "#",
    className: "".concat(prefixCls, "__dropdown-close"),
    onClick: function onClick(e) {
      e.preventDefault();
      close && close();
    }
  }, "\u5173\u95ED\u83DC\u5355"), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__dropdown-inner")
  }, curItem && /*#__PURE__*/_react.default.createElement("aside", {
    className: "".concat(prefixCls, "__dropdown-side")
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "".concat(prefixCls, "__caption-title")
  }, curItem.title), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__caption-desc")
  }, curItem.text), curItem.url && /*#__PURE__*/_react.default.createElement("a", {
    href: curItem.url,
    target: "_blank",
    rel: "noreferrer",
    className: "".concat(prefixCls, "__link")
  }, "\u4E86\u89E3\u66F4\u591A>")), /*#__PURE__*/_react.default.createElement("main", {
    className: "".concat(prefixCls, "__dropdown-content")
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: "".concat(prefixCls, "__dropdown-content-inner")
  }, /*#__PURE__*/_react.default.createElement("main", {
    className: "".concat(prefixCls, "__dropdown-main")
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "".concat(prefixCls, "__grid")
  }, dropdownMenu.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "".concat(prefixCls, "__col"),
      key: index
    }, item.map(function (menu, index) {
      return /*#__PURE__*/_react.default.createElement(_Menu.default, (0, _extends2.default)({
        curMenu: curItem === null || curItem === void 0 ? void 0 : curItem.action
      }, menu, {
        key: index,
        onClick: function onClick(res) {
          return onDropDown(res);
        }
      }));
    }));
  }))), /*#__PURE__*/_react.default.createElement("aside", {
    className: "".concat(prefixCls, "__dropdown-event")
  }, /*#__PURE__*/_react.default.createElement(_Search.default, {
    isActive: isActive,
    data: dropdownMenu,
    emptyList: emptyList,
    onChoose: function onChoose(res) {
      return onDropDown(res);
    }
  }))))));
};
var _default = exports.default = Dropdown;